<template>
  <div>
    <com-page>
      <com-card>
        <div class="mb-15px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="网点管理" name="0"></el-tab-pane>
            <el-tab-pane label="设备管理" name="1"></el-tab-pane>
            <el-tab-pane label="订单管理" name="2"></el-tab-pane>
            <el-tab-pane label="钱包管理" name="purse"></el-tab-pane>
          </el-tabs>
        </div>
        <the-site-list
          v-if="activeName === '0'"
          :defaultParams="{ partnerCode: businessCode }"
        ></the-site-list>
        <div v-if="activeName === '1'">
          <com-equ-search typeOfView="shop" @search="handleSearch"></com-equ-search>
          <com-equ-list :defaultParams="{ partnerCode: businessCode }" ref="table"></com-equ-list>
        </div>
        <div v-if="activeName === '2'">
          <com-order-search typeOfView="shop" @search="handleSearch"></com-order-search>
          <com-order-list
            :defaultParams="{ partnerCode: businessCode }"
            ref="table"
          ></com-order-list>
        </div>
        <div v-if="activeName === 'purse'">
          <!-- <partner-wallet
            :level="partnerData.level"
            :code="defaultParams.partnerCode"
          ></partner-wallet> -->
          <partner-wallet level="STORE" :code="businessCode"></partner-wallet>
        </div>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import theSiteList from '@/views/shop/components/the-site.list'
import utils from 'my-tools-library'
import PartnerWallet from '../partners/components/partner-wallet'

export default {
  components: { theSiteList, PartnerWallet },
  data() {
    return {
      activeName: '0',
      defaultParams: {},
      businessCode: ''
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleClick() {
      console.log('activeName :>> ', this.activeName)
    }
  },
  created() {
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'partners-index' })
      return
    }
    const { params } = this.$route
    this.businessCode = params.code
  }
}
</script>
